export default "__VITE_ASSET__C0sXXH$7__"